import { render, staticRenderFns } from "./CncBadgeDot.vue?vue&type=template&id=4f495c26"
import script from "./CncBadgeDot.vue?vue&type=script&lang=js"
export * from "./CncBadgeDot.vue?vue&type=script&lang=js"
import style0 from "./CncBadgeDot.vue?vue&type=style&index=0&id=4f495c26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports